import {format} from 'date-fns';

(() => {
    function render(element: Element) {
        const timestamp = element.getAttribute('data-timestamp');
        const outputFormat = element.getAttribute('data-format');
        if (timestamp === null || outputFormat === null) {
            return;
        }

        const formattedOutput = format(parseInt(timestamp, 10) * 1000, outputFormat);
        const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

        element.innerHTML = formattedOutput;
    }

    const elements = document.querySelectorAll('[data-timestamp]');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elements.length; ++i) {
        render(elements[i]);
    }
})();
